import BaseApi from './base'

class ServiceCenterAdmin extends BaseApi {
  getServiceCenterAdmins = (query) =>
    this.client.get(`admin/company/admins?${query}`)

  getServiceCenterAdminDetail = (id) =>
    this.client.get(`admin/company/admins/${id}`)

  getServiceCenterAdminPortalRole = (id) =>
    this.client.get(`admin/company/admins/${id}/portal-role`)

  addServiceCenterAdmin = (id, data) =>
    this.client.post(`admin/company/${id}/admins`, data)

  deleteServiceCenterAdmin = (id) =>
    this.client.delete(`admin/company/admins/${id}`)

  resendInvitation = (id) =>
    this.client.post(`admin/company/admins/${id}/resend-invitation`)

  updateServiceCenterAdminRole = (id, data) =>
    this.client.patch(`admin/company/admins/${id}`, data)
}

export default new ServiceCenterAdmin()
